module.exports = __webpack_public_path__ + "images/program/maquette.54defded.png";